import React from 'react'

function OnlinePayment() {
  return (
    <div>
      OnlinePayment
    </div>
  )
}

export default OnlinePayment
